import {
  Component,
  effect,
  inject,
  input,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { AnimateComponent } from '@app/components/animate/animate.component';
import { PolishPluralPipe } from '@app/pipes/polish-plural.pipe';
import { isPlatformServer, NgOptimizedImage } from '@angular/common';
import { FirstCharPipe } from '@app/pages/main-page/components/counter-section/pipes/first-char.pipe';
import { SecondCharPipe } from '@app/pages/main-page/components/counter-section/pipes/second-char.pipe';

@Component({
  selector: 'app-counter-section',
  templateUrl: './counter-section.component.html',
  styleUrls: ['./counter-section.component.scss'],
  standalone: true,
  imports: [
    AnimateComponent,
    PolishPluralPipe,
    NgOptimizedImage,
    FirstCharPipe,
    SecondCharPipe,
  ],
})
export class CounterSectionComponent {
  public date: Date | null = null;
  public now: number | null = null;
  public difference: number | null = null;

  public readonly targetDate = input.required<Date>();
  public readonly targetTime = signal<number>(0);
  private readonly _platformId = inject(PLATFORM_ID);

  public readonly dayPolishPlural = ['Dzień', 'Dni', 'Dni'];
  public readonly hourPolishPlural = ['Godzina', 'Godziny', 'Godzin'];
  public readonly minutePolishPlural = ['Minuta', 'Minuty', 'Minut'];

  public readonly days = signal<number>(0);
  public readonly hours = signal<number>(0);
  public readonly minutes = signal<number>(0);
  public readonly seconds = signal<number>(0);

  constructor() {
    effect(() => {
      const targetDateValue = this.targetDate();
      if (!targetDateValue) {
        return;
      }
      this.targetTime.set(targetDateValue.getTime());
      if (isPlatformServer(this._platformId)) {
        return;
      }
      setInterval(() => {
        this._start();
      }, 1000);
    });
  }

  private _start(): void {
    this.date = new Date();
    this.now = this.date.getTime();
    this.difference = this.targetTime() - this.now;
    this.difference = this.difference / (1000 * 60 * 60 * 24);
    if (this.difference < 0) {
      this.difference = 0;
    }
    this.days.set(Math.floor(this.difference));
    let hoursDifference = (this.difference - Math.floor(this.difference)) * 24;
    if (hoursDifference < 0) {
      hoursDifference = 0;
    }
    this.hours.set(Math.floor(hoursDifference));
    let minutesDifference =
      (hoursDifference - Math.floor(hoursDifference)) * 60;
    if (minutesDifference < 0) {
      minutesDifference = 0;
    }
    this.minutes.set(Math.floor(minutesDifference));
    let secondsDifference =
      (minutesDifference - Math.floor(minutesDifference)) * 60;
    if (secondsDifference < 0) {
      secondsDifference = 0;
    }
    this.seconds.set(Math.floor(secondsDifference));
  }
}
